import React from 'react';

export const uploadDescription = () => (
  <div>
    <h3 className="vads-u-font-size--h4">Supporting Documents</h3>
    <p>
      When you file a claim for Individual Unemployability, you’ll have a chance
      to provide supporting documents that show your disability prevents you
      from holding down a steady job.
    </p>
    <p>Some examples of supporting documents include:</p>
    <ul>
      <li>Medical records</li>
      <li>Social Security Administration Disability Determination</li>
      <li>Termination letters from past employers</li>
      <li>Supporting statements from coworkers or colleagues</li>
      <li>Absentee reports</li>
      <li>Your personal journal, diaries, or calendars</li>
    </ul>
    <p>Do you have supporting documents you’d like to upload?</p>
  </div>
);
